<template>
    <div>
        <div ref="chart"></div>
    </div>
</template>

<script>

    export default {
        props: ['headline', 'pattern', 'data'],

        data: function () {
            return {
                chart: null,
            }
        },

        computed: {
            yAxis: function () {
                return [
                    {
                        title: {
                            text: this.data.unit,
                            style: {
                                color: '#7cb5ec',
                            },
                        },
                        labels: {
                            style: {
                                color: '#7cb5ec'
                            }
                        },
                        //endOnTick: false,
                        opposite: true,
                    },
                    {
                        title: {
                            text: this.pattern.unit,
                        },
                        //endOnTick: false,
                    }
                ];
            },
            series: function () {
                var data = this.data.observations.filter(function (val) {
                    return val.value !== null && val.value !== '';
                }).map(function (val) {
                    return [Date.parse(val.time), val.value];
                });

                return [
                    {
                        name: this.data.description.en,
                        data: data,
                        yAxis: 0,
                    },
                    {
                        name: this.pattern.description.en,
                        data: this.pattern.observations.filter(function (val) {
                            return val.value !== null && val.value !== '';
                        }).map(function (val) {
                            return [Date.parse(val.time), val.value];
                        }),
                        yAxis: 1,
                    }
                ];
            },
        },

        mounted: function () {
            this.newChart();
        },

        methods: {
            newChart: function () {
                let text = '<span style="color:#434348">' + this.pattern.description.en + '</span>'
                    + '<br><span style="color:lightgray">correlates with</span><br>'
                    + '<span style="color:#7cb5ec">' + this.data.description.en + '</span>';

                this.chart = new Highcharts.Chart({
                    chart: {
                        renderTo: this.$refs.chart,
                    },
                    title: {
                        text: text,
                    },
                    subtitle: {
                        text: 'r = ' + this.data.r,
                    },
                    series: this.series,
                    yAxis: this.yAxis,
                    legend: {
                        itemStyle: {
                            width: 550,
                        },
                    },
                    exporting: {
                        buttons: {
                            contextButton: {
                                enabled: false,
                            }
                        }
                    },
                    credits: {
                        enabled: true,
                        href: 'https://now.allthatstats.com/',
                        text: 'Source: AllThatStatsNOW',
                    },
                    tooltip: {
                        shared: true,
                    }
                });
            }
        },
    }

</script>
